<template>
	<div class="page-in">
		<van-nav-bar :title="$t('个人信息')" fixed placeholder left-arrow z-index="99" @click-left="back" :border="false"
			v-if="isMobileFlag" />
		<div class="inside-page">
			<div class="m-container" >
				<div class="ucenter-cell">
					<div class="ucenter-previews">
						<div class="avatar-m-preview">
							<el-upload class="avatar-uploader" :action="rootUrl + '/upload/upload'"
								:show-file-list="false" :on-success="handleAvatarSuccess" :on-change="handleAvatarchange" :headers="uploadHeader">
								<div class="m-user-avatar">
									<img :src="userData.avatar && userData.avatar != '' ? userData.avatar : require('@/assets/images/head.png')"  />
									<span class="icon-upload-box" >
										<i class="el-icon-edit"></i>
									</span>
								</div>
							</el-upload>
						</div>
						<div class="ucenter-m-preview">
							<el-input v-model="userData.user_name" :placeholder="$t('用户名')"></el-input>
						</div>
						<div class="ucenter-m-preview" >
							<el-input  v-model="userData.email" :placeholder="$t('邮箱')"></el-input>
						</div>
						<div class="ucenter-m-preview">
							<el-select v-model="userData.sex" :placeholder="$t('请选择')" style="width: 100%;">
								<el-option :label="$t('请选择')" value="0"></el-option>
								<el-option :label="$t('男')" value="1"></el-option>
								<el-option :label="$t('女')" value="2"></el-option>
							</el-select>
						</div>
						<div class="ucenter-m-preview" >
							<el-input type="tel" v-model="userData.mobile" :placeholder="$t('手机')"></el-input>
						</div>
						<div class="ucenter-m-preview">
							<el-button type="primary" @click="onSubmit">{{$t('保存')}}</el-button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import helper from '@/common/helper.js';
	
	import {
		user_upload_api,user_save_api
	} from "@/api/user"
	export default {
		components: {},
		data() {
			return {
				edit: false,
				userData: {
					user_name:'',
					sex:'1',
					mobile:'',
					email:'',
					avatar:''
				},
				uploadHeader: {
					'api-login-token': '',
					'api-login-key': ''
				},
				rootUrl: process.env.VUE_APP_API_BASE_URL,
			};
		},
		methods: {
			handleAvatarSuccess(e) {
				if (e.code == 1) {
					this.userData.avatar = e.data;
				}
			},
			handleAvatarchange(e){
				const loading = this.$loading({
				  lock: true,
				  text: '',
				  spinner: 'loader',
				  background: 'rgba(255, 255, 255, 0.3)'
				});
				if(e.response){
					loading.close()
				}
			},
			async onSubmit() {
				let data = {
					user_name:this.userData.user_name,
					mobile:this.userData.mobile,
					email:this.userData.email,
					sex:this.userData.sex,
					avatar:this.userData.avatar,
				}
				const loading = this.$loading({
				  lock: true,
				  text: '',
				  spinner: 'loader',
				  background: 'rgba(255, 255, 255, 0.3)'
				});
				await user_save_api(data).then(res => {
					console.log(res.data)
					if (res && res.data.code == 1) {
						this.successTips(res.data.msg)
						this.$helper.set("userInfo", this.userData);
						loading.close()
						location.reload()
					}else{
						this.errorTips(res.data.msg)
						loading.close()
					}
				});
			},
		},
		mounted() {
			if(helper.get("userInfo") != ""){
				this.userData.user_name = helper.get("userInfo").user_name
				this.userData.mobile = helper.get("userInfo").mobile
				this.userData.email = helper.get("userInfo").email
				this.userData.sex = helper.get("userInfo").sex.toString()
				this.userData.avatar = helper.get("userInfo").avatar
			}
			let {token,token_key} = helper.get("tokenInfo");
			this.uploadHeader['api-login-token'] = token;
			this.uploadHeader['api-login-key'] = token_key;
		}
	}
</script>
<style scoped>
	.avatar-m-preview {
		padding: 30px 0;
	}

	.ucenter-m-preview {
		margin-bottom: 15px;
	}

	.ucenter-m-preview .el-button {
		width: 100%;
	}

	.avatar-uploader {
		margin: 0 auto;
		width: 100px;
	}

	.m-user-avatar {
		width: 100px;
		position: relative;
		text-align: center;
	}

	.m-user-avatar img {
		width: 100px;
		height: 100px;
		border-radius: 100px;
	}

	.icon-upload-box {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		bottom: -5px;
		left: 50%;
		margin-left: -15px;
		width: 30px;
		height: 30px;
		background-color: #f2f2f2;
		border-radius: 30px;
	}
</style>